<template>
  <div>
    <McEditableTable
      ref="table"
      v-show="isTableDataAvailable"
      searchable
      hasEmit:submitError
      :apiClient="apiClient"
      :fields="fields"
      :apiErrorMappings="reasonApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    />
    <div class="empty-table-container" v-show="!isTableDataAvailable">
      <McEmptyState
        :title="empyStateProps.title"
        :desc="empyStateProps.desc"
        @buttonPrimaryAction="handleAdd"
      />
    </div>
  </div>
</template>

<script>
import McEmptyState from '@/components/McEmptyState'
import McEditableTable from '@/components/McEditableTable'
import * as Reason from '@/services/rest-api/lib/delivery/reason'
import reasonApiErrorMappings from '../lib/constants/reason-api-error-mappings'

export default {
  components: {
    McEditableTable,
    McEmptyState,
  },
  data() {
    return {
      isTableDataAvailable: true,
      reasonApiErrorMappings,
    }
  },
  computed: {
    apiClient() {
      return {
        get: Reason.get("type eq 'CANCELED'"),
        show: Reason.show,
        store: Reason.storeCancelType,
        update: Reason.updateCancelType,
        delete: Reason.deleteSingle,
      }
    },
    fields() {
      return [
        {
          name: 'reason',
          label: this.$t('setting.reasonCancel.label'),
          placeholder: this.$t('setting.reasonCancel.placeholder'),
          key: 'reason',
          validation: 'required',
          editable: true,
          isSortable: true,
          help: true,
        },
      ]
    },
    empyStateProps() {
      return {
        title: this.$t('setting.reasonCancel.empty'),
        desc: this.$t('setting.reasonCancel.add'),
      }
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.reason && data.errors.reason[0] == 'value is not unique') {
          this.$mcToast.error('Gagal simpan. Alasan Pembatalan sudah terdaftar di sistem.')
          return
        }

        this.$mcToast.error('Terdapat kesalahan format pada input anda')
      }
    },
  },
}
</script>
